export default "__VITE_ASSET__BugIhSkT__"